<!--
  -  Copyright (c) Qwoach LLC 2022. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 26/12/2022
  -->

<template>
	<el-steps
		ref="stepsView"
		v-bind="$attrs"

		:active="activeStep"
		:direction="directionComputed"
		@chang="onStepChanged"
		class="qwoach-steps-root show-only-current-step finish-default" finish-status="success">
		<slot></slot>
	</el-steps>
</template>

<script>
import BaseComponent from "@/core/components/BaseComponent.vue";

export default {
	name: "QwSteps",
	extends: BaseComponent,
	inheritAttrs: false,

	props: {
		isVertical: {Boolean, default: true},
		activeStep: Number
	},

	// data() {
	// 	return {
	// 		steps: {
	// 			push(item){
	// 				this.$refs.stepsView.steps.push(item)
	// 			}
	// 		}
	// 	}
	// },

	methods: {
		onStepChanged() {
			console.log("onStepChanged")
		}
	},

	computed: {
		directionComputed() {
			return this.isVertical ? "vertical" : "horizontal"
		},

		// steps(){
		// 	return this.$refs.stepsView.steps
		// }
	},
}
</script>

<style lang="scss">
.qwoach-steps-root{
	&.steps-green{
		.is-success, .is-process {
			border-color: #67C23A;
		}
		.is-success {
			.el-step__line{
				background: #67C23A;
			}
		}

		.el-step__icon {
			background: #67C23A;
		}
	}
	.is-success, .is-process {
		border-color: #409EFF;
	}
	.is-success {
		.el-step__line{
			background: #409EFF;
		}
	}

	.el-step__icon {
		font-size: 12px;
		color: white;
		background: #409EFF;
	}

	.is-wait {
		.el-step__icon {
			background: #C0C4CC;
		}
	}
}

</style>
